import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, tap } from 'rxjs';
import { APP_CONFIG, PAGE } from '../core';


/**
* This service handles help modal.
*/
@Injectable({ providedIn: 'root' })
export class HelpService {

	private readonly http = inject(HttpClient);
	private readonly sanitizer = inject(DomSanitizer);
	private readonly config = inject(APP_CONFIG);

	private fileNameList: any;
	private _isLoaded: boolean = false;
	private _lang: string | null = null;


	/**
	 * Check if help file name list is loaded.
	 */
	get isLoaded(): boolean {
		return this._isLoaded;
	}

	/**
	 * Load help file name list.
	 */
	loadFileNames(lang: string): Observable<any> {
		return this.http.get(this.config.helpSite.fileNames).pipe(
			tap(list => {
				this._lang = lang;
				this.fileNameList = list;
				this._isLoaded = true;
			}));
	}

	/**
	 * Get safe url of help.
	 */
	get safeUrl(): SafeUrl | null {
		const url = this.helpUrl;
		return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
	}

	private get helpUrl(): string | null {
		const fileName = this.fileNameList ? this.fileNameList[this.fileKey] : null;
		return fileName ? `${this.config.helpSite.baseUrl}/${this._lang}/${fileName}.html` : null;
	}

	private get fileKey(): string {
		const pathName = globalThis.location.pathname;
		switch (pathName) {
			case `/${PAGE.DASHBOARD}`: return 'DASHBOARD';

			case `/${PAGE.PROFILE_EDIT}`: return 'PROFILE_EDIT';

			case `/${PAGE.PATIENT_NEW}`: return 'PATIENT_CREATE_EDIT';
			case `/${PAGE.PATIENT_EDIT}`: return 'PATIENT_CREATE_EDIT';

			case `/${PAGE.PLAN_NEW}`: return 'PLAN_CREATE_EDIT';
			case `/${PAGE.PLAN_EDIT}`: return 'PLAN_CREATE_EDIT';

			case `/${PAGE.LIST_PLANS}`: return 'PATIENT_PLAN_LIST';
			case `/${PAGE.LIST_RECEIVED}`: return 'PATIENT_PLAN_LIST';
			case `/${PAGE.LIST_ONLY_PLANS}`: return 'PATIENT_PLAN_LIST';

			default: return ''
		}
	}

}
